import { EnvironmentId } from '@/react/portainer/environments/types';

import { UserId } from '../types';

export const userQueryKeys = {
  base: () => ['users'] as const,
  list: (
    { includeAdministrator, environmentId } = {
      includeAdministrator: false,
      environmentId: 0,
    }
  ) => ['users', { includeAdministrator, environmentId }] as const,
  user: (id: UserId) => [...userQueryKeys.base(), id] as const,
  me: () => [...userQueryKeys.base(), 'me'] as const,
  authorizations: (id: EnvironmentId) =>
    [...userQueryKeys.base(), 'authorizations', id] as const,
  namespaceAuthorizations: (id: EnvironmentId) =>
    [...userQueryKeys.base(), 'authorizations', id, 'namespaces'] as const,
  memberships: (id: UserId) =>
    [...userQueryKeys.base(), 'memberships', id] as const,
};
